const timeline = {
	el: {
		win: $(window),
		timelineItem: $('.text-line__item'),
	},
	events() {
		this.el.timelineItem.each((i, e) => {
			const elementTop = $(e).offset().top,
				elementBottom = elementTop + $(e).outerHeight(),
				viewportTop = this.el.win.scrollTop(),
				viewportBottom = viewportTop + this.el.win.height(),
				inViewport = elementBottom > viewportTop && elementTop < viewportBottom;

			inViewport ? $(e).addClass('visible').siblings().removeClass('visible') : $(e).removeClass('visible')

		})


	},
	init() {
		this.el.win.on('scroll', () => {
			this.events();
		})
	}
}

timeline.init()